export const SET_FILTER_FOLDER_PROPERTIES = 'SET_FILTER_FOLDER_PROPERTIES';
export const SET_FILTER_FOLDER = 'SET_FILTER_FOLDER';
export const FETCH_FILTER_FOLDER = 'FETCH_FILTER_FOLDER';
export const SAVE_FILTER_FOLDER = 'SAVE_FILTER_FOLDER';
export const SET_COLLABORATION_LOADING = 'SET_COLLABORATION_LOADING';
export const TOGGLE_COMMENT_STATE = 'comment/toggleState';
export const CLEAR_STORES = 'CLEAR_STORES';
